// @ts-check
/* global module require */
'use_strict';

import { ToggleTabLink } from '../tv_utils/toggle_tab_link';

/**
 * Class to manage the UI for the products page.
 *
 * @property {object} elements An object of HTML elements.
 */
export class ProductPageView {

    /**
     * Instantiate and bind the elements.
     */
    constructor() {
        const yotpo_qna = document.getElementById('yotpo_qna');
        if (yotpo_qna) {
            const toggle_tab_links = document.getElementsByClassName('js-product-toggle-tab-link') as HTMLCollectionOf<HTMLElement>;
            const tabs = document.getElementsByClassName('js-product-tab') as HTMLCollectionOf<HTMLElement>;

            new ToggleTabLink(toggle_tab_links, tabs);

            // Remove specs tables margin-left on mobile.
            const specs_tables = document.getElementsByClassName('flex-grow__1');
            for (const specs_table of specs_tables) {
                if (window.innerWidth < 767) {
                    specs_table.classList.remove('tv-margin__left-10');
                }
            }

            // If the user is logged in, we want to put their email in for YOTPO Q&A and hide it.
            const user_id = <HTMLInputElement> document.getElementById('user_id');
            const user_name = <HTMLInputElement> document.getElementById('user_name');
            const user_email = <HTMLInputElement> document.getElementById('user_email');

            const observer = new MutationObserver(() => {
                const yotpo_name = <HTMLInputElement> document.getElementById('yotpo_input_question_username');
                const yotpo_email = <HTMLInputElement> document.getElementById('yotpo_input_question_email');
                const yotpo_user = <HTMLElement> document.querySelector(
                    '.yotpo-footer.yotpo-animation-opacity.visible'
                );
                if (user_id && parseInt(user_id.value, 10) > 0 && user_name && user_email &&
                    yotpo_name && yotpo_email && yotpo_user
                ) {
                    yotpo_name.value = user_name.value;
                    yotpo_email.value = user_email.value;
                    yotpo_user.style.overflow = 'hidden';
                    yotpo_user.style.maxHeight = '0px';
                }
                observer.disconnect();
            });
            observer.observe(yotpo_qna, { childList: true });
            // Remove undefined cells in ty-tables
            const responsive_headers = document.getElementsByClassName('ty-table__responsive-header') as HTMLCollectionOf<HTMLElement>;
            for (let i = 0; i < responsive_headers.length; i++) {
                if (responsive_headers[i].value == undefined) {
                    responsive_headers[i].classList.add('tv-display__none');
                }
            }
        }

        const more_products_block = <HTMLElement> document.getElementsByClassName('tv-more-products-block')[0];
        if (more_products_block) {
            this.adjust_more_products_block(more_products_block);
        }

        // Create a mutation observer to see if native mobile tabs have been created.
        const tabs_container  = document.getElementsByClassName('js-product-tabs-container')[0];
        let accordion_func_ran = false;

        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length && !accordion_func_ran) {
                    accordion_func_ran = true;
                    if (document.querySelector('.ui-accordion')) {
                        handle_accordion();
                        observer.disconnect();
                    }
                }
            });
        });

        const config = {
            childList: true,
            subtree: true,
            characterData: true
        };
          
        if (tabs_container) {
            observer.observe(tabs_container, config);
        }

        // Manage the toggling of mobile tabs if they exist.
        function handle_accordion() {
            accordion_func_ran = true;
            const accordion_headers = document.getElementsByClassName('ui-accordion-header') as HTMLCollectionOf<HTMLElement>;
            const accordion_contents = document.getElementsByClassName('ui-accordion-content') as HTMLCollectionOf<HTMLElement>;

            for (let i = 0; i < accordion_headers.length; i++) {
                accordion_headers[i].addEventListener('click', function toggle_accordion_content() {
                    if (accordion_headers[i].classList.contains('ui-state-active') 
                        && accordion_contents[i].classList.contains('ui-accordion-content-active') 
                        && !accordion_contents[i].classList.contains('hidden') 
                    ) {
                        accordion_headers[i].classList.remove('ui-accordion-header-active');
                        accordion_headers[i].classList.remove('ui-state-active');
                        accordion_contents[i].classList.remove('ui-accordion-content-active');
                        accordion_contents[i].style.display = 'none';
                    } else {
                        accordion_headers[i].classList.add('ui-accordion-header-active');
                        accordion_headers[i].classList.add('ui-state-active');
                        accordion_contents[i].classList.add('ui-accordion-content-active');
                        accordion_contents[i].style.display = 'block';
                    }
                    
                });
            }
        }
    }

    /**
     * Adjust the "More Products" block to remove unpopulated blocks for better flex display.
     * 
     * @param {HTMLElement} container is the "More Products" block
     * @returns {void}
     */
    adjust_more_products_block(container) : void {
        const more_products_columns = container.getElementsByClassName('ty-column4');
        if (more_products_columns.length <= 4) {
            container.getElementsByClassName('grid-list')[0].classList.add(
                'tv-display__flex',
                'justify_content__center'
            );
            for (let i = 0; i < more_products_columns.length; i++) {
                if (!more_products_columns[i].hasChildNodes()) {
                    // Remove empty columns and re-evaluate that iteration.
                    more_products_columns[i].remove();
                    i--;
                }
            }
        }
    }
}

/**
 * Looks for the native product block and if it exists, initializes an instance of the ProductPageView.
 *
 * @returns {void}
 */
export function init() {
    if (document.getElementsByClassName('ty-product-block').length > 0) {
        (() => new ProductPageView())();
    }
}
